import { resolve } from "ui-common/di";
import type { IAuthState } from "ui-common/services/auth/types";
import { rpc } from "ui-common/services/rpc";

let _isProcessingCheckout = false;
let _checkoutError = "";

export function isProcessingCheckout() {
  return _isProcessingCheckout;
}

export async function processPendingCheckout() {
  const authState = resolve<IAuthState>("authState");
  if (!authState.isAuthenticated.get()) {
    return;
  }

  _isProcessingCheckout = true;
  _checkoutError = "";

  const checkoutData = sessionStorage.getItem("pendingCheckout");
  if (!checkoutData) {
    return;
  }

  try {
    const checkout = JSON.parse(checkoutData) as
      | { type: "one-time"; contentType: "post" | "link"; contentId: string; influencerId: string; price: number }
      | { type: "subscription"; influencerId: string };

    const returnUrl = sessionStorage.getItem("checkoutReturnUrl") || undefined;

    if (checkout.type === "one-time") {
      const response = await rpc("create-one-time-checkout", {
        contentType: checkout.contentType,
        contentId: checkout.contentId,
        returnUrl,
      });

      if (!response.url) {
        throw new Error("Checkout URL not provided");
      }

      sessionStorage.removeItem("pendingCheckout");
      sessionStorage.removeItem("checkoutReturnUrl");

      window.location.href = response.url;
    } else if (checkout.type === "subscription") {
      const response = await rpc("create-subscription-checkout", {
        influencerId: checkout.influencerId,
        returnUrl,
      });

      console.log("STRIE Checkout: ", response);

      if (!response.url) {
        throw new Error("Checkout URL not provided");
      }

      sessionStorage.removeItem("pendingCheckout");
      sessionStorage.removeItem("checkoutReturnUrl");

      window.location.href = response.url;
    }
  } catch (error) {
    console.error("Error processing pending checkout:", error);
    _checkoutError = error instanceof Error ? error.message : "Failed to process checkout";
    _isProcessingCheckout = false;
  }

  return { checkoutError: _checkoutError, isProcessingCheckout: _isProcessingCheckout };
}
